import React from 'react';

import Image from '../image';

import homeTitleStyles from './home-cta.module.css';

const HomeCta = () => (
  <div>
    <a href="https://www.mangerbouger.fr/recettes-en-2-2/2020/" className={ homeTitleStyles.ctaPreviously }>
      <Image
        alt="Découvrez aussi les recettes de l'édition 2020."
        className=""
        path="previously.png"
      />
    </a>
  </div>
);

export default HomeCta;
